import { gql } from "@apollo/client";

const GET_LEVEL_DETAILS = gql`
  query LevelDetails($id: ID!) {
    levelDetails(id: $id) {
      id
      title
      chapters {
        id
        name
        topics {
          id
          title
        }
      }
    }
  }
`;

export default GET_LEVEL_DETAILS;
